
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1401Dialog extends Serenity.EntityDialog<Report_1401Row, any> {
        protected getFormKey() { return Report_1401Form.formKey; }
        protected getIdProperty() { return Report_1401Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1401Row.localTextPrefix; }
        protected getService() { return Report_1401Service.baseUrl; }
        protected getDeletePermission() { return Report_1401Row.deletePermission; }
        protected getInsertPermission() { return Report_1401Row.insertPermission; }
        protected getUpdatePermission() { return Report_1401Row.updatePermission; }

        protected form = new Report_1401Form(this.idPrefix);

    }
}